import { inject, Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular/lazy';
import { TranslationService } from './i18n/translation.service';
import { leggiErroreBackend } from '../shared/errori-backend';
import { unisciTesti } from '../shared/testi';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private translation = inject(TranslationService);
  alertManutenzione: any;
  alertAppObsoleta: any;
  genericError: any;
  constructor(
    private alertCtrl: AlertController,
  ) {
  }

  async alertGenericError() {
    if (this.genericError != undefined) {
      this.genericError.dismiss();
    }

    this.genericError = await this.alertCtrl.create({
      header: this.translation.t('alertError'),
      message: this.translation.t('alertErrorMessage'),
      buttons: ['OK']
    });

    await this.genericError.present();
  }
  async alertError(message) {
    const alert = await this.alertCtrl.create({
      header: this.translation.t('alertError'),
      message: message,
      buttons: ['OK']
    });

    await alert.present();
  }

  async alertWrongCredentials() {
    const alert = await this.alertCtrl.create({
      header: this.translation.t('alertUtentePassErrati'),
      message: this.translation.t('alertUtentePassRiprovare'),
      buttons: ['OK']
    });

    await alert.present();
  }

  async alertDateErrate() {
    const alert = await this.alertCtrl.create({
      header: this.translation.t('alertErroreLabel'),
      message: this.translation.t('alertErroreDateLabel'),
      buttons: ['OK']
    });

    await alert.present();

  }

  async alertAddressError() {
    const alert = await this.alertCtrl.create({
      header: this.translation.t('alertError'),
      message: this.translation.t('alertErrorMessage'),
      buttons: ['OK']
    });

    await alert.present();
  }

  // alertAddressError suggerisce il logout: per registrazione e recupero password serve un testo sulla rete
  async alertConnessioneAssente() {
    const alert = await this.alertCtrl.create({
      header: this.translation.t('alertConnessioneTitolo'),
      message: this.translation.t('alertConnessioneMessaggio'),
      buttons: ['OK']
    });

    await alert.present();
  }

  // Errore HTTP del backend: un codice con traduzione in chiaviPerCodice vince sul messaggio del server,
  // che resta come prima per i codici non previsti
  async alertErroreBackend(errore: unknown, chiaviPerCodice: Record<string, string> = {}) {
    const { rete, codice, messaggio } = leggiErroreBackend(errore);
    if (rete) {
      return this.alertConnessioneAssente();
    }
    if (codice && chiaviPerCodice[codice]) {
      return this.alertError(this.translation.t(chiaviPerCodice[codice]));
    }
    if (messaggio) {
      return this.alertError(messaggio);
    }
    return this.alertGenericError();
  }


  async svuotaOmbrelloneAlert() {
    const alert = await this.alertCtrl.create({
      header: this.translation.t('alertPrenotaOmbrellone'),
      message: this.translation.t('alertTempoScaduto'),
      buttons: ['OK']
    });

    await alert.present();
  }

  async massimoNumGGPrenotabiliErr(maxGg) {
    const alert = await this.alertCtrl.create({
      header: this.translation.t('alertErroreLabel'),
      message: this.translation.t('numeroMassimoGgPrenotabili') + ': ' + maxGg,
      buttons: ['OK']
    });
    await alert.present();

  }

  async massimoNumOmbrelloniPrenotabiliErr(maxOmbrelloni) {
    const alert = await this.alertCtrl.create({
      header: this.translation.t('oopsLabel'),
      message: unisciTesti(this.translation.t('numMaxOmbrelloniPrenotabiliLabel'), maxOmbrelloni),
      buttons: ['OK']
    });
    await alert.present();

  }



  async alertDopoUnaCertaOra(orarioLimite, isMezzeGiornateDisp) {
    const alert = await this.alertCtrl.create({
      header: this.translation.t('alertPrenotaOmbrellone'),
      message: unisciTesti(
        this.translation.t('alertDopoLeUndiciLabelStart'),
        orarioLimite,
        this.translation.t(isMezzeGiornateDisp ? 'alertDopoLeUndiciMezzeGiornateLabel' : 'alertDopoLeUndiciLabel')
      ),
      buttons: ["OK"],
    });
    await alert.present();
  }

  async alertGiorniPassatiFunc() {
    const alert = await this.alertCtrl.create({
      header: this.translation.t('alertErroreLabel'),
      message: this.translation.t('alertGiorniPassatiLabel'),
      buttons: ['OK']
    });
    await alert.present();
  }

  async erroreDateFunct() {
    const alert = await this.alertCtrl.create({
      header: this.translation.t('alertErroreLabel'),
      message: this.translation.t('alertErroreDateLabel'),
      buttons: ['OK']
    });
    await alert.present();
  }
  async alertTempoScaduto() {
    const alert = await this.alertCtrl.create({
      header: this.translation.t('alertPrenotaOmbrellone'),
      message: this.translation.t('alertTempoScaduto'),
      buttons: ['OK']
    });
    await alert.present();
  }
  async alertOmbrNonDispFunct() {

    const alert = await this.alertCtrl.create({
      header: this.translation.t('alertPrenotaOmbrellone'),
      message: this.translation.t('alertOmbrNonDispLabel'),
      buttons: ['OK']
    });
    await alert.present();

  }

  async alertVersionOutdate() {
    if (this.alertAppObsoleta != undefined) {
      this.alertAppObsoleta.dismiss();
    }

    this.alertAppObsoleta = await this.alertCtrl.create({
      header: this.translation.t('alertAppObsoleta'),
      message: this.translation.t('alertAppObsoletaMess'),
      buttons: ['OK']
    });

    await this.alertAppObsoleta.present();

  }

  async alertAppInManutenzione() {
    if (this.alertManutenzione != undefined) {
      this.alertManutenzione.dismiss();
    }
    this.alertManutenzione = await this.alertCtrl.create({
      header: this.translation.t('alertAppInAggiornamento'),
      message: this.translation.t('alertAppInAggiornamentoMess'),
      buttons: ['OK']
    });

    await this.alertManutenzione.present();

  }

  async alertDopoLeDodiciFunc() {
    const alert = await this.alertCtrl.create({
      header: this.translation.t('alertPrenotaRistorante'),
      message: this.translation.t('alertDopoLeDodiciLabel'),
      buttons: ['OK']
    });

    await alert.present();
  }

  async alertDopoLeVentiFunc() {
    const alert = await this.alertCtrl.create({
      header: this.translation.t('alertPrenotaRistorante'),
      message: this.translation.t('alertDopoLeVentiLabel'),
      buttons: ['OK']
    });

    await alert.present();
  }



  async presentAlertRecuperaPassword() {
    const alert = await this.alertCtrl.create({
      header: this.translation.t('resetPass_modificaLabel'),
      message: this.translation.t('resetPass_msgConfermaLabel'),
      buttons: ['OK']
    });

    await alert.present();
  }
}
